export interface IUser {
  username: string
  merchant: string
  roles: string[]
  abilities: any
  merchantPrefix?: string
  isNotAllowSeeCost?: boolean
  isEnableShippingSettings?: boolean
}

export interface IUserLists {
  objectId: string
  _id: string
  name: string
  username: string
  roles: string[]
  role: UserRole
  status: string
  image?: string
  abilities?: IAbilities[]
  phoneNumber?: string
  createdAt: string | Date
  updatedAt: string | Date
  latestLogin: string | Date
  isAvailable?: boolean
  isNotAllowDeleteItem?: boolean
  isNotAllowSeeCost?: boolean
  isEnablePackingSystem?: boolean
  isEnableShippingSettings?: boolean
}

export interface IAbilities {
  action: string | any
  subject: string | any
  fields?: string[] | any
}

export enum OrderStatus {
  PENDING = 'pending',
  TELESALE = 'telesale',
  SALEPAGE = 'salepage',
  SUCCESS = 'success',
  CANCLELLED = 'cancelled',
}

export enum UserRole {
  USER = 'user',
  ADMIN = 'admin',
  MERCHANT = 'merchant',
  HEAD = 'head',
  ADVERTISER = 'advertiser',
  AI = 'ai',
  SUPER_ADMIN = 'super_admin',
}

export enum UserRolesFormSelect {
  user = 'ผู้ใช้งานทั่วไป',
  admin = 'ผู้ดูแลระบบ',
  merchant = 'ผู้ประกอบการ',
  head = 'หัวหน้าแอดมิน',
}
